// removed by extract-text-webpack-plugin
module.exports = {"pagination-toggle-btn":"ObjectList__pagination-toggle-btn___35HCd","arrow-icon":"ObjectList__arrow-icon___3UdhX"};


//////////////////
// WEBPACK FOOTER
// ./src/views/ObjectList/ObjectList.less
// module id = 1611
// module chunks = 3